import { render, staticRenderFns } from "./column-row.vue?vue&type=template&id=a2a7734c&"
import script from "./column-row.vue?vue&type=script&lang=js&"
export * from "./column-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports